export enum ProtectionStatus {
  Allowed = "allowed",
  Blocked = "blocked",
}
